import React, { useState } from "react";

import Swal from "sweetalert2";

import { useNavigate } from "react-router-dom";

import QuillEditor from "../components/QuillEditor";

import API_BASE_URL from "../config/api";


const AddBlog = () => {

    const navigate = useNavigate();


    /* =========================================================
       STATES
    ========================================================= */

    const [saving, setSaving] = useState(false);

    const [imagePreview, setImagePreview] = useState("");

    const [formData, setFormData] = useState({
        title: "",
        description: "",
        sort_order: 1,
        image: null,
        date_added: ""
    });


    /* =========================================================
       INPUT CHANGE
    ========================================================= */

    const handleChange = (e) => {

        const {
            name,
            value,
            files
        } = e.target;


        /* =====================================================
           IMAGE
        ===================================================== */

        if (name === "image") {

            const file =
                files && files.length > 0
                    ? files[0]
                    : null;


            if (!file) {

                setFormData(previous => ({
                    ...previous,
                    image: null
                }));

                setImagePreview("");

                return;
            }


            /* =================================================
               IMAGE TYPE
            ================================================= */

            const allowedTypes = [
                "image/jpeg",
                "image/png",
                "image/webp",
                "image/gif"
            ];


            if (!allowedTypes.includes(file.type)) {

                Swal.fire({
                    icon: "warning",
                    title: "Invalid Image",
                    text:
                        "Only JPG, PNG, WEBP or GIF images are allowed."
                });

                e.target.value = "";

                return;
            }


            /* =================================================
               IMAGE SIZE
            ================================================= */

            if (file.size > 2 * 1024 * 1024) {

                Swal.fire({
                    icon: "warning",
                    title: "Image Too Large",
                    text:
                        "Image size should not exceed 2 MB."
                });

                e.target.value = "";

                return;
            }


            setFormData(previous => ({
                ...previous,
                image: file
            }));


            setImagePreview(
                URL.createObjectURL(file)
            );

            return;
        }


        /* =====================================================
           NORMAL INPUT
        ===================================================== */

        setFormData(previous => ({
            ...previous,
            [name]: value
        }));
    };


    /* =========================================================
       DESCRIPTION CHANGE
    ========================================================= */

    const handleDescriptionChange = (value) => {

        setFormData(previous => ({
            ...previous,
            description: value
        }));
    };


    /* =========================================================
       REMOVE IMAGE
    ========================================================= */

    const handleRemoveImage = () => {

        setFormData(previous => ({
            ...previous,
            image: null
        }));

        setImagePreview("");
    };


    /* =========================================================
       SUBMIT
    ========================================================= */

    const handleSubmit = async (e) => {

        e.preventDefault();


        /* =====================================================
           TITLE
        ===================================================== */

        if (
            !formData.title ||
            !formData.title.trim()
        ) {

            Swal.fire({
                icon: "warning",
                title: "Title Required",
                text: "Please enter blog title"
            });

            return;
        }


        /* =====================================================
           DESCRIPTION
        ===================================================== */

        if (
            !formData.description ||
            !formData.description.trim() ||
            formData.description === "<p><br></p>"
        ) {

            Swal.fire({
                icon: "warning",
                title: "Description Required",
                text: "Please enter blog description"
            });

            return;
        }


        /* =====================================================
           IMAGE
        ===================================================== */

        if (!formData.image) {

            Swal.fire({
                icon: "warning",
                title: "Image Required",
                text: "Please select blog image"
            });

            return;
        }


        try {

            setSaving(true);


            /* =================================================
               FORM DATA
            ================================================= */

            const data = new FormData();


            /* =================================================
               TITLE
            ================================================= */

            data.append(
                "title",
                formData.title.trim()
            );


            /* =================================================
               AUTHOR

               Author field frontend se nahi hai.
               Backend mein author ko empty string
               automatically handle karenge.
            ================================================= */


            /* =================================================
               DESCRIPTION
            ================================================= */

            data.append(
                "description",
                formData.description
            );


            /* =================================================
               SORT ORDER
            ================================================= */

            data.append(
                "sort_order",
                formData.sort_order || 1
            );


            /* =================================================
               DATE ADDED
            ================================================= */

            if (
                formData.date_added &&
                formData.date_added.trim()
            ) {

                data.append(
                    "date_added",
                    formData.date_added.trim()
                );
            }


            /* =================================================
               IMAGE
            ================================================= */

            data.append(
                "image",
                formData.image
            );


            /* =================================================
               API REQUEST
            ================================================= */

            const response = await fetch(
                `${API_BASE_URL}/admin/blogs`,
                {
                    method: "POST",

                    body: data,

                    credentials: "include",

                    headers: {
                        Accept: "application/json"
                    }
                }
            );


            const result =
                await response.json();


            console.log(
                "ADD BLOG RESPONSE:",
                result
            );


            /* =================================================
               SUCCESS
            ================================================= */

            if (
                response.ok &&
                result.success
            ) {

                await Swal.fire({
                    icon: "success",
                    title: "Success",
                    text:
                        result.message ||
                        "Blog added successfully",
                    timer: 1500,
                    showConfirmButton: false
                });


                navigate("/blogs");

                return;
            }


            /* =================================================
               VALIDATION ERROR
            ================================================= */

            if (result.errors) {

                const firstError =
                    Object.values(result.errors)
                        .flat()[0];

                Swal.fire({
                    icon: "warning",
                    title: "Validation Error",
                    text:
                        firstError ||
                        "Please check the form."
                });

                return;
            }


            /* =================================================
               ERROR
            ================================================= */

            Swal.fire({
                icon: "error",
                title: "Error",
                text:
                    result.message ||
                    "Unable to add blog"
            });


        } catch (error) {

            console.error(
                "Add blog error:",
                error
            );


            Swal.fire({
                icon: "error",
                title: "Server Error",
                text:
                    "Unable to connect with server"
            });


        } finally {

            setSaving(false);
        }
    };


    /* =========================================================
       CANCEL
    ========================================================= */

    const handleCancel = () => {

        if (saving) {
            return;
        }

        navigate("/blogs");
    };


    /* =========================================================
       RENDER
    ========================================================= */

    return (

        <div
            className="container-fluid py-4"
            style={{
                maxHeight: "500px",
                overflowX: "auto",
                overflowY: "auto"
            }}
        >



            {/* =================================================
                HEADER
            ================================================= */}

            <div
                className="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-4
                "
            >

                <div>

                    <h3 className="mb-1">
                        Add Blog
                    </h3>

                    <p className="text-muted mb-0">
                        Create a new website blog
                    </p>

                </div>


                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCancel}
                    disabled={saving}
                >
                    Back to Blogs
                </button>

            </div>


            {/* =================================================
                FORM CARD
            ================================================= */}

            <div className="card shadow-sm border-0">

                <div className="card-body">


                    <form onSubmit={handleSubmit}>

                        <div className="row g-3">


                            {/* =================================================
                                TITLE
                            ================================================= */}

                            <div className="col-md-8">

                                <label className="form-label">

                                    Blog Title

                                    <span className="text-danger">
                                        {" "}*
                                    </span>

                                </label>


                                <input
                                    type="text"
                                    name="title"
                                    className="form-control"
                                    value={formData.title}
                                    onChange={handleChange}
                                    placeholder="Enter blog title"
                                    maxLength="255"
                                    disabled={saving}
                                />

                            </div>


                            {/* =================================================
                                SORT ORDER
                            ================================================= */}

                            <div className="col-md-4">

                                <label className="form-label">
                                    Sort Order
                                </label>


                                <input
                                    type="number"
                                    name="sort_order"
                                    className="form-control"
                                    value={formData.sort_order}
                                    onChange={handleChange}
                                    min="1"
                                    disabled={saving}
                                />

                            </div>


                            {/* =================================================
                                DATE
                            ================================================= */}

                            <div className="col-md-4">

                                <label className="form-label">
                                    Date Added
                                </label>


                                <input
                                    type="text"
                                    name="date_added"
                                    className="form-control"
                                    value={formData.date_added}
                                    onChange={handleChange}
                                    placeholder="Example: Sep 25 2026"
                                    maxLength="50"
                                    disabled={saving}
                                />

                            </div>


                            {/* =================================================
                                IMAGE
                            ================================================= */}

                            <div className="col-md-4">

                                <label className="form-label">

                                    Blog Image

                                    <span className="text-danger">
                                        {" "}*
                                    </span>

                                </label>


                                <input
                                    type="file"
                                    name="image"
                                    className="form-control"
                                    accept="
                                        image/jpeg,
                                        image/png,
                                        image/webp,
                                        image/gif
                                    "
                                    onChange={handleChange}
                                    disabled={saving}
                                />


                                <small className="text-muted">

                                    JPG, PNG, WEBP or GIF

                                    <br />

                                    Maximum 2 MB

                                </small>

                            </div>


                            {/* =================================================
                                IMAGE PREVIEW
                            ================================================= */}

                            {imagePreview && (

                                <div className="col-12">

                                    <label className="form-label">
                                        Image Preview
                                    </label>


                                    <div
                                        className="
                                            d-flex
                                            align-items-start
                                            gap-3
                                        "
                                    >

                                        <img
                                            src={imagePreview}
                                            alt="Blog Preview"
                                            style={{
                                                width: "180px",
                                                height: "110px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                border: "1px solid #ddd"
                                            }}
                                        />


                                        <button
                                            type="button"
                                            className="
                                                btn
                                                btn-sm
                                                btn-outline-danger
                                            "
                                            onClick={handleRemoveImage}
                                            disabled={saving}
                                        >
                                            Remove
                                        </button>

                                    </div>

                                </div>

                            )}


                            {/* =================================================
                                DESCRIPTION
                            ================================================= */}

                            <div className="col-12">

                                <label className="form-label">

                                    Blog Description

                                    <span className="text-danger">
                                        {" "}*
                                    </span>

                                </label>


                                <QuillEditor
                                    value={formData.description}
                                    allowImage={true}
                                    onChange={
                                        handleDescriptionChange
                                    }
                                />

                            </div>


                        </div>


                        {/* =================================================
                            BUTTONS
                        ================================================= */}

                        <div className="mt-4 d-flex gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleCancel}
                                disabled={saving}
                            >
                                Cancel
                            </button>


                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={saving}
                            >

                                {saving ? (

                                    <>

                                        <span
                                            className="
                                                spinner-border
                                                spinner-border-sm
                                                me-2
                                            "
                                        />

                                        Saving...

                                    </>

                                ) : (

                                    "Save Blog"

                                )}

                            </button>

                        </div>


                    </form>

                </div>

            </div>

        </div>
    );
};


export default AddBlog;